import { httpApi } from '@app/api/http.api';

export interface InspirationModel {
  id: string;
  imageUrl: string;
  link: string;
  order: number;
  updatedAt: number;
}

export interface Pagination {
  current?: number;
  pageSize?: number;
  total?: number;
  defaultPageSize?: number;
  showSizeChanger?: boolean;
  pageSizeOptions?: string[] | number[];
}

export interface UpdateInspirationData {
  link: string;
  order: number;
}

export const getInspirationList = async () => {
  return httpApi.get('/inspirations');
};

export const createInspiration = (data: UpdateInspirationData): Promise<InspirationModel> =>
  httpApi.post<InspirationModel>(`/inspirations`, { ...data }).then(({ data }) => data);

export const updateInspiration = (id: string, data: UpdateInspirationData): Promise<undefined> =>
  httpApi.patch<undefined>(`/inspirations/${id}`, { ...data }).then(({ data }) => data);

export const updateInspirationImage = async (id: string, image: File) => {
  const payload = new FormData();
  payload.append('file', image);
  return httpApi.patch(`/inspirations/${id}/image`, payload).then(({ data }) => data);
};

export const deleteInspiration = (id: string): Promise<undefined> =>
  httpApi.delete<undefined>(`/inspirations/${id}`).then(({ data }) => data);
